/**
 * The Hiring tab's (Hiring Hub) URL shapes, in one place — the route table, the header tab and the pages all
 * build these paths. Like every department tab it lives under `/:departmentId`: `/{department}/hiring-chat`.
 */

/** The Hiring Hub's path segment, right after the department — also the page's pattern in the route table. */
export const HIRING_HUB_SEGMENT = "hiring-chat";

/** Static segment under `hiring-chat` that selects one candidate's profile. */
const CANDIDATE_SEGMENT = "candidate";

/** The profile route's pattern, for the route table (relative to `/:departmentId`). */
export const HIRING_HUB_CANDIDATE_ROUTE = `${HIRING_HUB_SEGMENT}/${CANDIDATE_SEGMENT}/:candidateId`;

/** The Hiring Hub in one department. */
export const hiringHubPath = (departmentId: string): string => `/${departmentId}/${HIRING_HUB_SEGMENT}`;

/** One candidate's profile page. */
export const hiringHubCandidatePath = (departmentId: string, candidateId: string): string =>
	`${hiringHubPath(departmentId)}/${CANDIDATE_SEGMENT}/${candidateId}`;
